import { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion";

export const selectIngredientGenericValues = (
    ingredientGenericValues: SsqVersion["ingredientGenericValues"],
    ingredientReferenceId: number | undefined,
): Partial<Record<number, string>> => {
    if (ingredientReferenceId === undefined) {
        return {};
    }

    return Object.fromEntries(
        (ingredientGenericValues ?? [])
            .filter((genericValue) => genericValue.ingredientReferenceId === ingredientReferenceId)
            .map((genericValue) => [genericValue.ssqPropertyId, genericValue.value]),
    );
};
